'use strict'
import Vue from 'vue' 
import VueRouter from 'vue-router' 

import App from './App.vue' 
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import router from './router.js'
import Vuex from 'vuex'
import store from './vuex/store'
import Vant from 'vant'
import 'vant/lib/index.css'
import ElementUI from 'element-ui'
import 'element-ui/lib/element-#315B83/index.css'
Vue.use(ElementUI)
Vue.use(Vant)
require('es6-promise').polyfill()
Vue.use(Vuex)
App.store = store
Vue.use(VueRouter) 
Vue.directive('transfer-dom', TransferDom)

import axios from 'axios'
import qs from 'qs'
Vue.prototype.$http = axios

axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'

axios.interceptors.request.use(
config => {

if (config.method === 'post') {
config.data = qs.stringify(config.data)
}
config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
if (window.localStorage.getItem('auth') && window.localStorage.getItem('auth') !== '') {  // 判断是否存在token，如果存在的话，则每个http header都加上token
config.headers.token = `${window.localStorage.getItem('auth')}`
}
return config
},
err => {
return Promise.reject(err)
}
)
/* eslint-disable no-new */
new Vue({
el: '#root',
router,
render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js